// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sw{position:relative;display:inline-block;padding:2px}.sw .sw-option{position:relative;padding:11px 22px;text-align:center;cursor:pointer;white-space:nowrap}.sw .sw-target{position:absolute;padding:0 22px;height:calc(100% - 4px)}.sw.round .sw-target{border-radius:inherit}.sw .sw-option,.sw .sw-target{transition:.4s}.sw.lg .sw-option{padding:13px 26px}.sw.lg .sw-target{padding:0 26px}", ""]);
// Exports
module.exports = exports;
